// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import VModal from 'vue-js-modal';
import Snotify, { SnotifyPosition } from 'vue-snotify';
import Vuetify from 'vuetify';

import App from './App';
import './assets/css/all.scss';
import './registerServiceWorker';
import store from './store';

Vue.config.productionTip = false;

Vue.use(VModal, { dynamic: true, injectModalsContainer: true });

Vue.use(Snotify, {
  toast: {
    position: SnotifyPosition.rightTop,
  },
});

Vue.use(Vuetify);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  components: { App },
  template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.js